import React from 'react';
import {Redirect} from 'react-router-dom';

const Profile1=()=> {

    return (
        <Redirect to='/profile' />
    )
}

export default Profile1
